import script from "./MaterialProductCards.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialProductCards.vue?vue&type=script&setup=true&lang=js"

import "./MaterialProductCards.vue?vue&type=style&index=0&id=3f7a364f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f7a364f"]])

export default __exports__